import React from "react";
import {
  getExtensionPageLabel,
  isExtensionEditorSurfacePreview,
} from "../../../shared/extension-preview.js";

/**
 * Neutral backdrop for extension editor previews (replaces storefront WebsiteBackground).
 */
const ExtensionPageBackground = ({ surface }) => {
  const pageLabel = getExtensionPageLabel(surface);

  if (isExtensionEditorSurfacePreview(surface)) {
    return (
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "#f6f6f7",
          pointerEvents: "none",
        }}
        data-extension-background={surface || ""}
        aria-hidden
      />
    );
  }

  return (
    <div
      style={{
        flex: 1,
        minHeight: 0,
        width: "100%",
        padding: "18px",
        background: "#e3e7ee",
        boxSizing: "border-box",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
      data-extension-background={surface || ""}
      aria-label={`${pageLabel} preview background`}
    >
      <div
        style={{
          position: "relative",
          width: "100%",
          flex: 1,
          minHeight: 0,
          borderRadius: "14px",
          background: "#f0f2f6",
          border: "1px solid #c5ccd8",
          boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.85)",
          overflow: "hidden",
        }}
      />
    </div>
  );
};

export default ExtensionPageBackground;
